import { useState } from 'react';
import { SkrillEmailField } from './SkrillEmailField';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface Props {
  /**
   * Notifies the parent of the latest email and its validity. Fires on
   * every keystroke (not on mount) so the parent can keep its mirror of
   * the validity flag in sync without an initial false-positive `null`.
   */
  onSelectionChange: (value: { email: string; isValid: boolean }) => void;
  /**
   * True once the form has been touched (parent-owned, tied to the shared
   * `useAmountInput` touched flag). Used to suppress the inline email
   * error until the user has interacted somewhere.
   */
  touched: boolean;
  /**
   * Notify the parent that the panel changed; used to clear any
   * outstanding server error.
   */
  onUserInput: () => void;
}

/**
 * Owns skrill-mode state — just the email field. No Pay.com surface, so
 * no setup view; the picker IS the panel.
 */
export function SkrillWithdrawPanel({ onSelectionChange, touched, onUserInput }: Props) {
  const [skrillEmail, setSkrillEmail] = useState('');

  function handleChange(next: string) {
    setSkrillEmail(next);
    const trimmed = next.trim();
    onSelectionChange({ email: trimmed, isValid: EMAIL_RE.test(trimmed) });
    onUserInput();
  }

  const showError = touched && skrillEmail.length > 0 && !EMAIL_RE.test(skrillEmail.trim());

  return <SkrillEmailField value={skrillEmail} onChange={handleChange} error={showError ? 'Enter a valid email.' : null} />;
}
